import styled from 'styled-components'
import {spacing} from '../../../theme/spacing'

export const ErrorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing(2)};
    padding: ${spacing(4)};
`

export const ErrorMessage = styled.span`
    color: ${(props) => props.theme.colors.text.default};
`
